export default __webpack_public_path__ + "static/nectar-e1081ab78d1b73f4f642e8943cf9af6f.svg";